export default "__VITE_ASSET__BX8_b$hQ__"